var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilterIconMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M7.25 1c.414 0 .812.166 1.105.46.293.295.457.695.457 1.111v3.143c0 .417-.164.817-.457 1.111a1.558 1.558 0 01-2.21 0 1.576 1.576 0 01-.457-1.11V2.57c0-.416.164-.816.457-1.11C6.438 1.165 6.835 1 7.25 1v0z",
    stroke: "#9C1A87",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 4.143H8.812M5.688 4.143H1",
    stroke: "#9C1A87",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M7.25 16.714c.414 0 .812.166 1.105.46.293.295.457.695.457 1.112v3.143c0 .416-.164.816-.457 1.11a1.558 1.558 0 01-2.21 0 1.576 1.576 0 01-.457-1.11v-3.143c0-.417.164-.817.457-1.111.293-.295.69-.46 1.105-.46z",
    stroke: "#9C1A87",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26 19.857H8.812M5.688 19.857H1",
    stroke: "#9C1A87",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M19.75 8.857c.414 0 .812.166 1.105.46.293.295.457.695.457 1.112v3.142c0 .417-.164.817-.457 1.112a1.558 1.558 0 01-2.21 0 1.576 1.576 0 01-.457-1.112V10.43c0-.417.164-.817.457-1.112.293-.294.69-.46 1.105-.46v0z",
    stroke: "#9C1A87",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.188 12H1M26 12h-4.688",
    stroke: "#9C1A87",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgFilterIconMap;